import type { IntlMessage } from '@rovo-extension/i18n';
import { defineMessages } from 'react-intl';

type MessageKey = 'localDevBannerLabel';

export const messages: Record<MessageKey, IntlMessage> = defineMessages({
	localDevBannerLabel: {
		id: 'rovo-extension.local-dev-banner.label.no-translate',
		defaultMessage: 'LOCAL DEV',
		description:
			'The text is shown as a banner label at the top of the extension UI when running in local development mode to distinguish it from production. This string should NOT be translated.',
	},
});
